export const CARDS_BLOCK_b14 = {
  "blockType": "CARDS",
  "blockDesign": "BYOCards",
  "editFormName": "DESIGN_CARD_PANEL",
  "styleProps": {
    "background-color": "#F2F2FC",
    "padding": "120px 20px 120px 20px"
  },
  "headings": [
    {
      "text": "Our Leadership Team",
      "styleProps": {
        "text-align": "center",
        "color": "#333333",
        "font-size": "3.75rem",
        "line-height": "1",
        "font-weight": "600"
      },
      "stylePropsTab": {
        "font-size": "3rem",
        "line-height": "1"
      },
      "stylePropsMob": {
        "font-size": "1.875rem",
        "line-height": "2.25rem"
      }
    },
    {
      "text": "Meet the visionaries behind our company:",
      "styleProps": {
        "color": "#333333",
        "font-size": "1.5rem",
        "line-height": "2rem",
        "margin": "30px 0px 80px 0px",
        "text-align": "center"
      },
      "stylePropsTab": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "margin": "30px 0px 60px 0px"
      },
      "stylePropsMob": {
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "margin": "30px 0px 50px 0px"
      }
    }
  ],
  "cardElements": [
    {
      "type": "image",
      "id": 1746549445569,
      "elIndex": 0,
      "text": "",
      "location": "A",
      "params": {
        "value": "img",
        "label": "img"
      },
      "imgStyleProps": {
        "height": "120px",
        "width": "120px",
        "border-radius": "9999px",
        "box-shadow": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
        "border-width": "8px",
        "border-color": "#ffffff"
      }
    },
    {
      "type": "text",
      "id": 1746529638292,
      "elIndex": 1,
      "text": "[[name]]",
      "location": "A",
      "params": [
        {
          "value": "name",
          "label": "name"
        }
      ],
      "styleProps": {
        "color": "",
        "font-size": "1.875rem",
        "line-height": "2.25rem",
        "font-weight": "500",
        "margin": "0px 0px 0px 0px",
        "padding": "40px 0px 0px 0px"
      },
      "stylePropsTab": {
        "font-size": "2.25rem",
        "line-height": "2.5rem",
        "margin": "0px 0px 0px 0px"
      },
      "stylePropsMob": {
        "font-size": "1.875rem",
        "line-height": "2.25rem",
        "margin": "0px 0px 0px 0px"
      }
    },
    {
      "type": "text",
      "id": 1746531362022,
      "elIndex": 2,
      "text": "[[role]]",
      "location": "A",
      "params": [
        {
          "value": "role",
          "label": "role"
        }
      ],
      "styleProps": {
        "margin": "10px 0px 0px 0px",
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "color": "",
        "font-weight": "400",
        "opacity": "0.8"
      },
      "stylePropsTab": {
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "margin": "0px 0px 0px 0px"
      },
      "stylePropsMob": {
        "font-size": "0.875rem",
        "line-height": "1.25rem",
        "margin": "1px 0px 0px 0px"
      }
    },
    {
      "type": "text",
      "id": 1746548627463,
      "elIndex": 3,
      "text": "[[description]]",
      "location": "B",
      "params": [
        {
          "value": "description",
          "label": "description"
        }
      ],
      "styleProps": {
        "color": "#333333",
        "margin": "0px 0px 30px 0px",
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "opacity": "1"
      },
      "stylePropsTab": {
        "font-size": "1rem",
        "line-height": "1.5rem"
      },
      "stylePropsMob": {
        "font-size": "1rem",
        "line-height": "1.5rem"
      }
    },
    {
      "type": "button",
      "id": 1746549783251,
      "elIndex": 4,
      "text": "View Profile",
      "location": "B",
      "btnStyleProps": {
        "background-color": "",
        "color": "#0D0D41",
        "border-width": "0px",
        "border-radius": "9999px",
        "padding": "16px 0px 16px 0px",
        "border-color": "",
        "font-size": "1.25rem",
        "line-height": "1.75rem"
      },
      "styleProps": {
        "margin": "0px 0px 0px 0px"
      },
      "btnStylePropsMob": {
        "padding": "12px 0px 12px 0px"
      }
    }
  ],
  "cardConfig": {
    "perRow": {
      "mobile": 1,
      "tab": 2,
      "desktop": 3
    },
    "layout": "l3",
    "cardstyleProps": {
      "padding": "10px 10px 40px 10px"
    },
    "cardstylePropsMob": {
      "padding": "10px 0px 10px 0px"
    },
    "cardstylePropsTab": {
      "padding": "10px 10px 10px 10px"
    },
    "alternate": true
  },
  "configs": {
    "dataType": "dynamic",
    "connection": {
      "spreadsheetId": "",
      "sheetName": "",
      "connectionId": "",
      "connectionTable": "",
      "timestamp": 1747074959933
    },
    "params": [],
    "filters": {
      "categories": []
    },
    "searchConfig": {
      "showSearchBar": false,
      "searchButton": {
        "styleProps": {
          "color": "#ffffff",
          "padding": "5px 20px 5px 20px",
          "background-color": "#333333",
          "border-radius": "1.5rem",
          "margin": "0px 10px 0px 10px",
          "font-weight": "bold",
          "width": "auto"
        },
        "stylePropsMob": {
          "width": "auto"
        }
      },
      "clearButton": {
        "styleProps": {
          "background-color": "#ececec",
          "color": "#333333",
          "padding": "5px 20px 5px 20px",
          "border-radius": "9999px"
        }
      },
      "searchContainer": {
        "styleProps": {
          "background-color": "#ececec",
          "border-radius": "1.5rem",
          "padding": "10px 20px 10px 10px",
          "margin": "30px 0px 30px 0px",
          "width": "auto"
        },
        "stylePropsTab": {
          "border-radius": "9999px"
        },
        "stylePropsMob": {
          "border-radius": "1rem",
          "width": "100%"
        }
      },
      "input": {
        "styleProps": {
          "border-radius": "9999px",
          "padding": "5px 20px 5px 20px",
          "color": "#333333",
          "font-weight": "100",
          "background-color": "#ffffff",
          "width": "auto"
        },
        "stylePropsMob": {
          "margin": "0px 0px 10px 0px",
          "width": "100%"
        }
      }
    },
    "sortBy": {
      "columnName": "",
      "ascending": true
    },
    "id": "1723883803066"
  },
  "metaDataId": 1747074958543,
  "afterIndex": 13,
  "blockId": 1747074958543,
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  },
  "stylePropsMob": {
    "padding": "60px 20px 60px 20px"
  },
  "cardLocations": [
    {
      "name": "outer",
      "styleProps": {
        "background-image": "linear-gradient(to bottom,,)",
        "border-radius": "3.5rem",
        "padding": "0px 0px 0px 0px",
        "background-repeat": "no-repeat",
        "background-size": "cover",
        "background-color": "#A884FE",
        "box-shadow": "8px 8px 2px 0px rgb(0 0 0 / 1)",
        "width": "none",
        "margin": "0px 0px 0px 0px",
        "color": "#ffffff",
        "border-width": "2px",
        "border-color": "#333333"
      },
      "stylePropsTab": {
        "border-radius": "1rem",
        "width": "auto",
        "padding": "0px 0px 0px 0px"
      },
      "stylePropsMob": {
        "border-radius": "0.75rem",
        "width": "auto",
        "padding": "0px 0px 0px 0px"
      }
    },
    {
      "name": 0
    },
    {
      "name": "A",
      "styleProps": {
        "background-color": "",
        "margin": "0px 0px 0px 0px",
        "border-radius": "3.5rem 3.5rem 0rem 0rem",
        "padding": "12px 12px 12px 12px",
        "box-shadow": "",
        "alignItems": "",
        "justify-content": "center",
        "flex-direction": "column",
        "display": "flex",
        "width": "100%",
        "text-align": "left",
        "background-image": "linear-gradient(to right,,)",
        "background-repeat": "no-repeat",
        "background-position": "center",
        "background-size": "cover",
        "color": "#333333"
      },
      "innerDiv": {
        "styleProps": {
          "height": "auto",
          "width": "auto",
          "border-radius": "50%",
          "background-image": "linear-gradient(to right,,)",
          "padding": "40px 30px 30px 30px",
          "display": "flex",
          "flex-direction": "column",
          "alignItems": "flex-start",
          "justify-content": "flex-start"
        },
        "stylePropsTab": {
          "height": "auto"
        },
        "stylePropsMob": {
          "height": "auto"
        }
      },
      "stylePropsMob": {
        "padding": "0px 0px 0px 0px",
        "width": "100%"
      }
    },
    {
      "name": "B",
      "styleProps": {
        "padding": "30px 40px 40px 40px",
        "display": "flex",
        "flex-direction": "column",
        "justify-content": "",
        "width": "100%",
        "alignItems": "",
        "text-align": "left",
        "box-shadow": "",
        "border-radius": "0rem 0rem 3.5rem 3.5rem",
        "background-color": "",
        "background-image": "linear-gradient(to right,,)"
      },
      "stylePropsTab": {
        "padding": "20px 20px 20px 20px"
      },
      "stylePropsMob": {
        "padding": "14px 14px 14px 14px",
        "width": "100%"
      },
      "innerDiv": {
        "styleProps": {
          "width": "auto",
          "display": "",
          "flex-direction": "",
          "alignItems": "",
          "justify-content": ""
        },
        "stylePropsMob": {
          "width": "auto"
        }
      }
    },
    {
      "name": "C",
      "styleProps": {
        "width": "100%",
        "display": "flex",
        "flex-direction": "row",
        "alignItems": "center",
        "justify-content": "center",
        "text-align": "center"
      },
      "innerDiv": {
        "styleProps": {
          "width": "auto",
          "display": "flex",
          "flex-direction": "row",
          "alignItems": "center",
          "justify-content": "center",
          "background-color": "#ffffff",
          "padding": "0px 0px 0px 0px"
        }
      }
    }
  ],
  "overlay": {
    "styleProps": {
      "background-color": "#F9FAFE"
    }
  },
  "containerStyleProps": {
    "max-width": "1280px"
  }
}